function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["prefixClass", "wrapClassName", "className", "placeholder", "onFocus", "onBlur", "onChange", "prefix", "suffix", "wrapStyle", "clearIcon", "value", "type", "max", "min", "onCompositionStart", "onCompositionEnd", "composition", "onKeyDown", "readOnly", "instance"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, forwardRef, useEffect, useImperativeHandle } from "react";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames;
  var prefixClass = props.prefixClass,
    wrapClassName = props.wrapClassName,
    className = props.className,
    placeholder = props.placeholder,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onChange = props.onChange,
    prefix = props.prefix,
    suffix = props.suffix,
    wrapStyle = props.wrapStyle,
    clearIcon = props.clearIcon,
    valueProp = props.value,
    type = props.type,
    max = props.max,
    min = props.min,
    _onCompositionStart = props.onCompositionStart,
    _onCompositionEnd = props.onCompositionEnd,
    composition = props.composition,
    _onKeyDown = props.onKeyDown,
    readOnly = props.readOnly,
    instance = props.instance,
    inputProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(valueProp),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    lock = _useState6[0],
    setLock = _useState6[1];
  useImperativeHandle(instance, function () {
    return {
      mutate: function mutate(v) {
        return setValue(v || valueProp);
      }
    };
  });
  useEffect(function () {
    if (valueProp !== value) {
      setValue(valueProp);
    }
  }, [valueProp]);
  var focus = function focus(ev) {
    setFocus(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(ev);
  };
  var blur = function blur(ev) {
    setFocus(false);
    onBlur && onBlur(ev);
  };
  var clear = function clear(ev) {
    setValue("");
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: "",
      event: ev,
      isClear: true
    });
  };
  var onInput = function onInput(ev) {
    var v = ev.currentTarget.value;
    if (type === "number") {
      if ((min || min === 0) && Number(v) < min) {
        v = min.toString();
      }
      if ((max || max === 0) && Number(v) > max) {
        v = max.toString();
      }
    }
    setValue(v);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: v,
      event: ev
    });
  };
  return /*#__PURE__*/_jsxs("span", {
    className: classNames("".concat(prefixClass, "InputWrap"), wrapClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixClass, "InputWrap--focus"), isFocus), _defineProperty(_classNames, "".concat(wrapClassName, "--focus"), isFocus), _classNames)),
    style: wrapStyle,
    children: [prefix, /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      ref: ref,
      className: classNames("".concat(prefixClass, "Input"), className)
    }, inputProps), {}, {
      type: type,
      value: value,
      readOnly: readOnly,
      onInput: onInput,
      onKeyDown: function onKeyDown() {
        if (!composition || !lock) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown.apply(void 0, args);
        }
      },
      onFocus: focus,
      onBlur: blur,
      placeholder: placeholder,
      onCompositionStart: function onCompositionStart() {
        setLock(true);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        _onCompositionStart === null || _onCompositionStart === void 0 ? void 0 : _onCompositionStart.apply(void 0, args);
      },
      onCompositionEnd: function onCompositionEnd() {
        setLock(false);
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        _onCompositionEnd === null || _onCompositionEnd === void 0 ? void 0 : _onCompositionEnd.apply(void 0, args);
      }
    })), clearIcon !== false && value && /*#__PURE__*/_jsx("span", {
      onClick: clear,
      className: "".concat(prefixClass, "InputClear"),
      children: clearIcon || "清空"
    }), suffix]
  });
});
Input.defaultProps = {
  prefixClass: "yk",
  placeholder: "请输入",
  composition: false
};
export default Input;